import * as React from "react";
import { SVGProps } from "react";

const Waltonchain = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 86" {...props}>
    <path fill="#8400fd" d="m34 57.1-30 9-1-57 30-7z" />
    <path
      fill="#fff"
      d="M6 68.1c-1.3 0-2.5-.4-3.6-1.1C.9 66 0 64.4 0 62.7V10.9c0-2.5 1.9-4.6 4.5-5.2L29 .2c1.9-.4 3.9-.1 5.5 1S37 4 37 5.8v50.3c0 2.5-1.9 4.8-4.6 5.5L7.7 67.9c-.6.1-1.1.2-1.7.2zM27.9 6.3c-.3 0-.7 0-1 .1l-19 4.8c-1.7.4-3 2-3 3.8v45c0 1.2.6 2.4 1.6 3.1s2.2 1 3.4.6l19.2-5.5c1.8-.5 3.1-2.2 3.1-4.1V10.5c0-1.3-.6-2.5-1.6-3.3-.9-.6-1.8-.9-2.7-.9z"
    />
    <path fill="#02ffdb" d="m55 76.1-30 9-1-57 30-7z" />
    <path
      fill="#fff"
      d="M27.7 86c-1.2 0-2.4-.4-3.4-1.1-1.4-1-2.3-2.5-2.3-4.2V30.6c0-2.4 1.8-4.5 4.3-5l23.2-5.3c1.8-.4 3.7 0 5.2 1 1.5 1.1 2.3 2.7 2.3 4.4v48.7c0 2.5-1.8 4.7-4.4 5.3l-23.4 6.1c-.5.1-1 .2-1.5.2zm21.2-61.7c-.3 0-.7 0-1 .1l-19 4.8c-1.7.4-3 2-3 3.8v45c0 1.2.6 2.4 1.6 3.1s2.2 1 3.4.6l19.2-5.5c1.8-.5 3.1-2.2 3.1-4.1V28.5c0-1.3-.6-2.5-1.6-3.3-.9-.6-1.8-.9-2.7-.9z"
    />
    <path fill="#8400fd" d="m78 58.1-30 9-1-57 30-7z" />
    <path
      fill="#fff"
      d="M50.7 68.1c-1.2 0-2.4-.4-3.4-1.1-1.4-1-2.3-2.5-2.3-4.2V12.5c0-2.4 1.8-4.5 4.3-5l23.1-5.3c1.8-.4 3.7 0 5.2 1 1.5 1.1 2.3 2.7 2.3 4.4v48.8c0 2.5-1.8 4.7-4.4 5.3l-23.3 6.1c-.5.2-1 .3-1.5.3zM71.9 6.3c-.3 0-.7 0-1 .1l-19.1 4.8c-1.7.4-3 2-3 3.8v45c0 1.2.6 2.4 1.6 3.1s2.3 1 3.5.6L73 58.2c1.8-.5 3.1-2.2 3.1-4.1V10.5c0-1.3-.6-2.5-1.6-3.3-.8-.6-1.7-.9-2.6-.9z"
    />
    <path fill="#02ffdb" d="m101 76.1-30 9-1-57 30-7z" />
    <path
      fill="#fff"
      d="M73 86.1c-1.3 0-2.5-.4-3.6-1.1-1.5-1-2.4-2.6-2.4-4.3V28.9c0-2.5 1.9-4.6 4.5-5.2L96 18.2c1.9-.4 3.9-.1 5.5 1s2.5 2.8 2.5 4.5V74c0 2.5-1.9 4.8-4.6 5.5l-24.7 6.3c-.6.2-1.1.3-1.7.3zm21.9-61.8c-.3 0-.7 0-1 .1l-19 4.8c-1.7.4-3 2-3 3.8v45c0 1.2.6 2.4 1.6 3.1s2.2 1 3.4.6l19.2-5.5c1.8-.5 3.1-2.2 3.1-4.1V28.5c0-1.3-.6-2.5-1.6-3.3-.9-.6-1.8-.9-2.7-.9z"
    />
    <path fill="#8400fd" d="m124 57.1-30 9-1-57 30-7z" />
    <path
      fill="#fff"
      d="M95 68.1c-1.3 0-2.5-.4-3.6-1.1-1.5-1-2.4-2.6-2.4-4.3V10.9c0-2.5 1.9-4.6 4.5-5.2L118 .2c1.9-.4 3.9-.1 5.5 1S126 4 126 5.7V56c0 2.5-1.9 4.8-4.6 5.5l-24.7 6.3c-.6.2-1.1.3-1.7.3zm21.9-61.8c-.3 0-.7 0-1 .1l-19 4.8c-1.7.4-3 2-3 3.8v45c0 1.2.6 2.4 1.6 3.1s2.2 1 3.4.6l19.2-5.5c1.8-.5 3.1-2.2 3.1-4.1V10.5c0-1.3-.6-2.5-1.6-3.3-.9-.6-1.8-.9-2.7-.9z"
    />
  </svg>
);

export default Waltonchain;
